<app-header></app-header>
<app-toolbar></app-toolbar>

<div class="user-wrapper"  (window:resize)="onResize($event)">
    <app-search-option class="app-search-option"></app-search-option>
    <div class="user-content-sec">
       <router-outlet></router-outlet>
    </div>
</div>
